import React from 'react'
import PropTypes from 'prop-types';
import {ToggleButton, ToggleButtonGroup} from "@material-ui/lab";
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';


const ratings = [
    {
        rating: 0,
        icon: <SentimentVeryDissatisfiedIcon/>,
        label: 'Very Dissatisfied',
    },
    {
        rating: 1,
        icon: <SentimentVeryDissatisfiedIcon/>,
        label: 'Very Dissatisfied',
    },
    {
        rating: 2,
        icon: <SentimentVeryDissatisfiedIcon/>,
    },
    {
        rating: 3,
        icon: <SentimentDissatisfiedIcon/>,
    },
    {
        rating: 4,
        icon: <SentimentDissatisfiedIcon/>,
    },
    {
        rating: 5,
        icon: <SentimentDissatisfiedIcon/>,
    },
    {
        rating: 6,
        icon: <SentimentDissatisfiedIcon/>,
    },
    {
        rating: 7,
        icon: <SentimentSatisfiedIcon/>,
    },
    {
        rating: 8,
        icon: <SentimentSatisfiedIcon/>,
    },
    {
        rating: 9,
        icon: <SentimentSatisfiedAltIcon/>,
    },
    {
        rating: 10,
        icon: <SentimentVerySatisfiedIcon/>,
    }];

function PollNpsSwitch(
    {
        scoreChange,
        score,
        classes = {},
    }) {

    return (
        <ToggleButtonGroup className={classes.root} size="large" value={score} exclusive onChange={scoreChange}>
            {
                ratings.map((x) => <ToggleButton className={classes.button} key={x.rating} value={x.rating}>
                    {"" + x.rating} {x.icon}
                </ToggleButton>)
            }
        </ToggleButtonGroup>
    )
}

PollNpsSwitch.propTypes = {
    scoreChange: PropTypes.func.isRequired,
    score: PropTypes.number,
    classes: PropTypes.shape({
        root: PropTypes.string,
        button: PropTypes.string
    })
}

export default PollNpsSwitch;